function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useCallback } from "react";
import { usePopperTooltip } from "react-popper-tooltip";
import { useTranslations } from "../../hooks/useTranslations";
import { CloseCircle } from "../Icons";
import { useKnockFeed } from "../KnockFeedProvider";

var ArchiveButton = _ref => {
  var {
    item
  } = _ref;
  var {
    colorMode,
    feedClient
  } = useKnockFeed();
  var {
    t
  } = useTranslations();
  var onClick = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    feedClient.markAsArchived(item);
  }, [item]);
  var {
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible
  } = usePopperTooltip({
    placement: "top-end"
  });
  return /*#__PURE__*/React.createElement("button", {
    ref: setTriggerRef,
    "aria-label": t("archiveNotification"),
    onClick: onClick,
    type: "button",
    className: "rnf-archive-notification-btn rnf-archive-notification-btn--".concat(colorMode)
  }, /*#__PURE__*/React.createElement(CloseCircle, null), visible && /*#__PURE__*/React.createElement("div", _extends({
    ref: setTooltipRef
  }, getTooltipProps({
    className: "rnf-tooltip rnf-tooltip--".concat(colorMode)
  })), t("archiveNotification")));
};

export { ArchiveButton };
//# sourceMappingURL=ArchiveButton.js.map